import type { ValueSignature } from "@skilitics/nautilus-core-designer-data";

import type { ValueSubtypeDefinition } from "../valueSubtypeDefinition.ts";
import { baseValueSubtypeDefinition } from "./baseDefinitions.ts";

/**
 * The definition governing an expression over a value of `signature`: the
 * contributed definition matching the subtype, else the base definition for the
 * base type.
 *
 * A subtype nobody contributed a definition for falls back to the base rather
 * than failing — the expression is still a comparison of that base type, and an
 * author facing a plain number form can still repair the design. It warns
 * because it means a definition list is missing an entry, not because the design
 * is wrong.
 */
export const resolveValueSubtypeDefinition = (
  signature: ValueSignature,
  contributed: readonly ValueSubtypeDefinition[],
): ValueSubtypeDefinition => {
  const { type, subtype } = signature;
  if (!subtype) return baseValueSubtypeDefinition(type);

  const match = contributed.find((definition) => definition.id === subtype.id && definition.type === type);
  if (match) return match;

  console.warn(`No ValueSubtypeDefinition contributed for subtype "${subtype.id}" of ${type}; using the base type.`);
  return baseValueSubtypeDefinition(type);
};
